import { Controller } from "stimulus";

import TomSelect from "tom-select";

export default class extends Controller {
  static targets = ["job", "material"];

  connect() {
    this.jobSelect = new TomSelect(this.jobTarget, {
      copyClassesToDropdown: false,
    });
    this.jobSelect.on("change", (v) => {
      const materialsOnJob = window.job_and_material_ids[v];

      if (materialsOnJob) {
        materialsOnJob.forEach((materialId) => {
          const material = window.materials.find((m) => m.id == materialId);

          if (material) {
            this.materialSelect.updateOption(String(materialId), {
              ...material,
              id: String(material.id),
              substrateType: "00job",
            });
          }
        });
      } else {
        // reset all options to default
        window.materials.forEach((material) => {
          this.materialSelect.updateOption(String(material.id), {
            ...material,
            id: String(material.id),
          });
        });
      }
    });
    const currentMaterialId = this.materialTarget.value;
    const materialOptions = window.materials.map((m) => ({ ...m, id: String(m.id) }));
    this.materialSelect = new TomSelect(this.materialTarget, {
      copyClassesToDropdown: false,
      valueField: "id",
      searchField: ["substrateCode", "name"],
      options: materialOptions,
      items: currentMaterialId ? [String(currentMaterialId)] : [],
      sortField: [{ field: "substrateType" }, { field: "$score" }],
      optgroups: [
        { value: "00job", label: "In Job" },
        { value: "board", label: "Board" },
        { value: "roll", label: "Roll" },
        { value: "adhesive", label: "Adhesive" },
        { value: "laminate", label: "Laminate" },
      ],
      optgroupField: "substrateType",
      render: {
        option: function (data, escape) {
          return `<div><div>${escape(data.name)}</div><div><small>${escape(
            data.substrateCode
          )}</small></div></div>`;
        },
        item: function (data, escape) {
          return `<div>${escape(data.name)}</div>`;
        },
      },
    });
  }

  update(e) {
    console.log(this.materialSelect);
    console.log(e);
  }
}
